import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {
  Button,
  Row,
  Col,
  Input,
  Container
} from 'src/components/Common/reactstrap/lib';
import Checkbox from 'src/components/Checkbox/Checkbox';
import Breadcrumbs from 'src/components/Breadcrumbs/Breadcrumbs';

import moment from 'moment';
import "moment/locale/ru";

import {isPortionStateSelected, filterSelectedPortion} from 'src/logic/helpers/orderStateHelper';

import * as actions from './redux/userInmotionAction';
import styles from './Orders.scss';
import OrdersTable from './elements/OrdersTable';
import SelectDate from '../Common/SelectDate';
import {exportUserOrdersToXlsx} from '../../logic/api';

export class Orders extends Component {
  constructor(props) {
    super(props);
    const from = new Date(moment().subtract(1, 'M')),
      to = new Date(moment());
    this.state = {
      popoverOpen: false,
      filterBy: '',
      selected: false,

      from,
      to,

      isProgress: false,
      isCanceled: false,
      isReady: false,
      isArchived: false,
    };
    this.handleDayClick = this.handleDayClick.bind(this);

    this.termSearch = this.termSearch.bind(this);
    this.sendOrderToXls = this.sendOrderToXls.bind(this);

    moment.locale('ru');

    this.getOrders();
    this.props.actions.fetchPortionStates();
  }

  getOrders = (page= 0) => {
    console.log(page);
    let {from, to, isProgress, isReady, isCanceled, isArchived} = this.state,
      filters = {
        startDate: moment(from).format('YYYY.MM.DD'),
        finishDate: moment(to).add(1, 'd').format('YYYY.MM.DD'),
        rowsCount: 100,
        isProgress,
        isReady,
        isCanceled,
        isArchived,
        page,
      };
    this.props.actions.onFetchUserInmotions(filters);
  };
  setCheckbox = (el) => {
  let name = el.target.name;
    console.log(name);
    this.setState({
      [name]: !this.state[name]
    }, this.getOrders)
  };
  handleDayClick(range) {
    this.setState(Object.assign(range, {
      selected: true
    }), this.getOrders);
  }

  termSearch(filterBy) {
    this.setState({
      filterBy
    });
  }

  sendOrderToXls(ordersData) {

    if(ordersData)
      exportUserOrdersToXlsx(ordersData.orders)
        .then(response => response.blob())
        .then(blob => URL.createObjectURL(blob))
        .then(url => {
          let a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = "заказы.xlsx";
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        });
  }


  render() {
    let {from, to} = this.state;
console.log(this);
    return (
      <Container>
        <Breadcrumbs
          routes={this.props.routes}/>
        <h2>Заказы { this.state.selected ? (
          <span> c { moment(from).format('ll') } по { moment(to).format('ll')} </span>) : (
          <span>за 30 дней</span>)}</h2>
        <Row className={styles.filters + ' justify-content-between'}>
          <Col sm={3}>
            <Input value={this.state.filterBy} onChange={event => this.termSearch(event.target.value)}
                   placeholder="Поиск"/>
          </Col>
          <Col sm={1} className={styles.checkbox_filters}>
            <Checkbox text="в работе"
                      name="isProgress"
                      checked={this.state.isProgress}
                      onChange={this.setCheckbox}/>
          </Col>
          <Col sm={1} className={styles.checkbox_filters}>
            <Checkbox text="отменен"
                      name="isCanceled"
                      checked={this.state.isCanceled}
                      onChange={this.setCheckbox}/>
          </Col>
          <Col sm={1} className={styles.checkbox_filters}>
            <Checkbox text="готов"
                      name="isReady"
                      checked={this.state.isReady}
                      onChange={this.setCheckbox}/>
          </Col>
          <Col sm={1} className={styles.checkbox_filters}>
            <Checkbox text="архив"
                      name="isArchived"
                      checked={this.state.isArchived}
                      onChange={this.setCheckbox}/>
          </Col>
          <Col sm={1} className={styles.checkbox_filters + 'p-0 aria-pressed'}
               onClick={() => this.sendOrderToXls(this.props.userData.Inmotions)}>
            Экспорт в <span className={styles.green_box}>xls</span>
          </Col>
          <Col sm={3}>
            <SelectDate
              placement="bottom right"
              from={from}
              to={to}
              setDate={this.handleDayClick}
            />
          </Col>
        </Row>
        <OrdersTable
          OrdersData={this.props.userData.Inmotions}
          setArchive={this.props.actions.portionToArchive}
          loadMore={this.getOrders}
          filterBy={this.state.filterBy}
        />

      </Container>
    );
  }
}
Orders.routeTitle = "Заказы";
export default connect(
  (state) => ({
    userData: state.userReducer
  }),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
  })
)(Orders);



/** WEBPACK FOOTER **
 ** ./src/components/User/Orders.jsx
 **/